import { render } from "./AlertBlock.vue?vue&type=template&id=ba5d1e34&scoped=true"
import script from "./AlertBlock.vue?vue&type=script&lang=js"
export * from "./AlertBlock.vue?vue&type=script&lang=js"

import "./AlertBlock.vue?vue&type=style&index=0&id=ba5d1e34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5d1e34"]])

export default __exports__